import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const PrivacyPolicy = () => {
  const theme = useTheme();
  return (
    <Box sx={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a1833 0%, #1a2238 100%)',
      py: { xs: 2, sm: 4, md: 6 },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: { xs: 'center', md: 'flex-start' },
        justifyContent: 'center',
        width: '100%',
        maxWidth: '1100px',
        gap: { xs: 2, md: 6 },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: { xs: 2, md: 0 } }}>
        <Button href="/" sx={{ minWidth: 0, p: 0, borderRadius: '50%', bgcolor: 'transparent', boxShadow: 'none', '&:hover': { bgcolor: 'rgba(0,0,0,0.08)' } }}>
          <img src="gtt-logo.png" alt="Home"
            style={{
              height: 'auto',
              width: '100%',
              maxWidth: '240px',
              marginBottom: 8,
              display: 'block',
            }}
            sizes="(max-width: 600px) 80px, (max-width: 900px) 120px, 240px"
          />
        </Button>
      </Box>
      <Container maxWidth="md" sx={{
        background: 'rgba(10,24,51,0.85)',
        borderRadius: 4,
        boxShadow: '0 8px 32px 0 rgba(0,0,0,0.25)',
        p: { xs: 2, sm: 4, md: 6 },
        color: '#fff',
      }}>
        <Typography
          variant="h3"
          gutterBottom
          sx={{
            fontWeight: 900,
            textTransform: 'uppercase',
            color: '#fff',
            letterSpacing: '0.04em',
            mb: 2,
            fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
            textAlign: { xs: 'center', md: 'left' },
            wordBreak: 'break-word',
          }}
        >
          Privacy Policy
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          Effective date: August 20, 2025
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          GT Telemetry ("we", "us", or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our web application.
        </Typography>
        <Typography variant="h5" gutterBottom sx={{ color: '#fff', mt: 4 }}>
          Information We Collect
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          We may collect information you provide directly to us, such as your email address, uploaded files, and any other information you choose to provide. We may also collect certain technical information automatically, such as your IP address, browser type, and usage data.
        </Typography>
        <Typography variant="h5" gutterBottom sx={{ color: '#fff', mt: 4 }}>
          How We Use Your Information
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          We use your information to operate, maintain, and improve our services, to communicate with you, and to comply with legal obligations. We do not sell your personal information to third parties.
        </Typography>
        <Typography variant="h5" gutterBottom sx={{ color: '#fff', mt: 4 }}>
          Data Security
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          We implement reasonable security measures to protect your information. However, no method of transmission over the Internet or electronic storage is 100% secure.
        </Typography>
        <Typography variant="h5" gutterBottom sx={{ color: '#fff', mt: 4 }}>
          Your Choices
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          You may contact us at any time to request access to, correction of, or deletion of your personal information.
        </Typography>
        <Typography variant="h5" gutterBottom sx={{ color: '#fff', mt: 4 }}>
          Changes to This Policy
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page.
        </Typography>
        <Typography variant="h5" gutterBottom sx={{ color: '#fff', mt: 4 }}>
          Contact Us
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          If you have any questions about this Privacy Policy, please contact us at contact@gt-telemetry.com.
        </Typography>
        <Typography variant="h5" gutterBottom sx={{ color: '#fff', mt: 4 }}>
          Cookie Policy & Advertising
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          We use cookies that are essential for the operation of this app, such as for session management and authentication. These cookies are necessary for you to use the core features of the service and cannot be disabled.
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          <strong>Advertising & Google AdSense:</strong> This website displays advertisements served by Google AdSense. Third-party vendors, including Google, use cookies to serve ads based on your prior visits to this website or other websites. These cookies may be used for personalized or non-personalized advertising, depending on your choices and consent.
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: '#fff' }}>
          You may see a consent message from Google regarding ad personalization and cookies. For more information about how Google uses data when you use our site, please visit <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer" style={{ color: '#0072CE', textDecoration: 'underline' }}>Google's Privacy & Terms</a> and <a href="https://adssettings.google.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#0072CE', textDecoration: 'underline' }}>Google Ad Settings</a>.
        </Typography>
      </Container>
    </Box>
  </Box>
  );
};

export default PrivacyPolicy;
